export default __webpack_public_path__ + "media/components/Courses/Show/Images/disciplines/7-a00cdb90ec2b3047430c0c03f1697843.svg";